export enum ContractType {
  MeterContract = "ZVZ",
  OrderContract = "ZVV",
}

export const mapToContractType = (contractType: string): ContractType => {
  if (Object.values(ContractType).includes(contractType as ContractType))
    return contractType as ContractType;

  throw new Error("Unknown contract type");
};
